import * as React from 'react';
import classNames from 'classnames';
import './radioCardNoBorder.module.scss';
import { RadioButton } from './RadioCard';

type Props = {
  id?: string;
  checked: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  label: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCheck: (checked: boolean) => any;
  widthType?: 's' | 'm' | 'l';
  className?: string;
  styleName?: string;
  metaAttributes?: object;
};

export const RadioCardNoBorder = ({
  id,
  label,
  checked,
  onCheck,
  className,
  widthType = 'm',
  metaAttributes = {},
}: Props) => (
  <div
    id={id}
    styleName={classNames('radio-card', widthType, { checked: checked })}
    className={classNames('radio-card', widthType, className, { checked: checked })}
    onClick={() => onCheck(!checked)}
    {...metaAttributes}
  >
    <RadioButton checked={checked} onCheck={onCheck} styleName="radio" />
    {label}
  </div>
);
